import { FC } from 'react';
import { pdf } from '@react-pdf/renderer';
import DailyReportPDF from '../../../components/UI/PdfReport/DailyReportPDF';
import { usePdfReportData } from '../../../hooks/usePdfReportData';
import { TextButton } from '../Button/Text';
import { format } from 'date-fns';

interface IProps {
    date: string;
}

const DownloadLink: FC<IProps> = ({ date }) => {
    const [data, dataLoaded] = usePdfReportData(date);

    if (!dataLoaded) return null;

    const handleDownloadAll = async () => {
        for (const project of data.projects) {
            const filename = `${project.name} - Report of ${format(new Date(date), 'MMMM do, yyyy')}.pdf`;
            
            // Generate the PDF blob
            const blob = await pdf(<DailyReportPDF data={{ ...data, projects: [project] }} />).toBlob();
            
            // Create a download link and trigger it
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-start', marginLeft: '20px' }}>
            <TextButton label="Download All Reports" onClick={handleDownloadAll} />
        </div>
    );
};

export default DownloadLink;